import type { TrigKey } from './keys';

export const hi: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'गणित · त्रिकोणमिति',
  'panel.experiment': 'प्रयोग',
  'panel.params': 'पैरामीटर',
  'panel.scene': 'प्रयोग चुनें',
  'experiment.right-triangle.label': 'समकोण त्रिभुज',
  'experiment.unit-circle.label': 'इकाई वृत्त',
  'experiment.wave-studio.label': 'तरंग स्टूडियो',
  'experiment.identity-playground.label': 'सर्वसमिकाएँ',
  'experiment.triangle-solver.label': 'त्रिभुज हल',
  'experiment.circular-polar.label': 'वृत्तीय व ध्रुवीय',
  'hint.line1': 'बिंदु खींचें और स्लाइडर हिलाएँ।',
  'hint.line2': 'शिक्षा ज्यामिति में है, पाठ में नहीं।',
  'rt.angle.a': 'कोण A',
  'rt.angle.b': 'कोण B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'रेडियन',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° पर स्नैप',
  'uc.units': 'इकाइयाँ',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC दिखाएँ',
  'uc.snap.common': 'सामान्य कोण पर स्नैप',
  'uc.angle.value': '∠',
  'uc.units.deg': 'डिग्री',
  'uc.units.rad': 'रेड',
  'uc.units.both': 'डिग्री+रेड',
  'ws.fn': 'फलन',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — आयाम',
  'ws.frequency': 'B — आवृत्ति',
  'ws.phase': 'C — कलांतर',
  'ws.shift': 'D — ऊर्ध्वाधर शिफ्ट',
  'ws.rform.toggle': 'R-रूप व्युत्पत्ति',
  'ws.rform.a': 'a (sin गुणांक)',
  'ws.rform.b': 'b (cos गुणांक)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'रीसेट',
  'ws.base': 'आधार वक्र दिखाएँ',
  'ip.id.pythagorean': 'पाइथागोरस',
  'ip.id.reciprocal': 'व्युत्क्रम',
  'ip.id.quotient': 'भागफल',
  'ip.id.sum': 'योग',
  'ip.id.difference': 'अंतर',
  'ip.id.double': 'द्विकोण',
  'ip.id.half': 'अर्धकोण',
  'ip.play': 'चलाएँ',
  'ip.pause': 'रोकें',
  'ip.step': 'कदम',
  'ip.reset': 'रीसेट',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2 में आएगा — इस प्रमाण को अधिक विस्तृत निर्माण चाहिए।',
  'ts.area': 'क्षेत्रफल',
  'ts.sineRule': 'ज्या नियम',
  'ts.cosineRule': 'कोज्या नियम',
  'ts.ambiguous.toggle': 'अस्पष्ट होने पर भूत त्रिभुज',
  'ts.reset': 'समबाहु पर रीसेट',
  'ts.snap.integers': 'पूर्णांकों पर स्नैप',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'भुजाएँ',
  'ts.section.angles': 'कोण',
  'ts.section.sineRule': 'ज्या नियम',
  'ts.section.cosineRule': 'कोज्या नियम',
  'ts.section.area': 'क्षेत्रफल',
  'cp.omega': 'कोणीय वेग',
  'cp.plot.y': 'y प्लॉट (sin)',
  'cp.plot.x': 'x प्लॉट (cos)',
  'cp.polar.label': 'ध्रुवीय आकृति',
  'cp.polar.circle': 'वृत्त (r = 1)',
  'cp.polar.rose': 'गुलाब (r = sin 3θ)',
  'cp.polar.cardioid': 'हृदयाकार (r = 1 + cos θ)',
  'cp.polar.limacon': 'लिमासन (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'सूक्ष्म-कोण सन्निकटन (sin x ≈ x)',
  'cp.play': 'चलाएँ',
  'cp.pause': 'रोकें',
  'cp.reset': 'रीसेट',
  'cp.step': 'कदम π/12',
};
